import { render, staticRenderFns } from "./BrandschutzView.vue?vue&type=template&id=b75ce71a&"
import script from "./BrandschutzView.vue?vue&type=script&lang=js&"
export * from "./BrandschutzView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports